import { AxiosError, AxiosResponse } from 'axios';
import { Dispatch } from '@reduxjs/toolkit';

import { GlobalService } from './global.service';

import { AXIOS, CommonGlobalService, UUID, CallbackErrorAxios, CallbackWarningAxios, Equipment, EquipmentsId } from '@umanforge/common';
import { API } from 'constants/api.contants';
import { TaskEquipment } from 'interfaces/task_equipment.interface';

export class TaskEquipmentService {

  static getEquipmentsByTaskId(
    taskId: UUID,
    token: string | null, dispatch: Dispatch,
    onError?: CallbackErrorAxios, onWarning?: CallbackWarningAxios
  ): Promise<Equipment[]> {
    return new Promise( async resolve => {
      AXIOS.get( `${API.EQUIPMENTS_BY_TASK}/${taskId}`, await CommonGlobalService.getHeaderRequest( token ) )
        .then( ( response: AxiosResponse<Equipment[]> ) => {
          CommonGlobalService.saveRequestToken( response, dispatch );
          if ( response.status === 202 ) {
            GlobalService.onAxiosWarning( response, onWarning );
          }
          resolve( response.data );
        } )
        .catch( ( err: AxiosError ) => {
          GlobalService.onAxiosError( err, dispatch, onError );
        } );
    } );
  }

  static getTaskEquipmentByTasksId(
    taskIds: UUID[],
    token: string | null, dispatch: Dispatch,
    onError?: CallbackErrorAxios, onWarning?: CallbackWarningAxios
  ): Promise<TaskEquipment[]> {
    return new Promise( async resolve => {
      AXIOS.get( `${API.TASK_EQUIPMENT_BY_TASKS}`, { ...( await CommonGlobalService.getHeaderRequest( token ) ), params: { taskIds: taskIds } } )
        .then( ( response: AxiosResponse<TaskEquipment[]> ) => {
          CommonGlobalService.saveRequestToken( response, dispatch );
          if ( response.status === 202 ) {
            GlobalService.onAxiosWarning( response, onWarning );
          }
          resolve( response.data );
        } )
        .catch( ( err: AxiosError ) => {
          GlobalService.onAxiosError( err, dispatch, onError );
        } );
    } );
  }

  static postEquipmentsByTask(
    taskId: UUID,
    body: EquipmentsId,
    token: string | null, dispatch: Dispatch,
    onError?: CallbackErrorAxios, onWarning?: CallbackWarningAxios
  ): Promise<boolean> {
    return new Promise( async resolve => {
      AXIOS.post( `${API.TASK_EQUIPMENTS}/${taskId}`, body, await CommonGlobalService.getHeaderRequest( token ) )
        .then( ( response: AxiosResponse<string> ) => {
          CommonGlobalService.saveRequestToken( response, dispatch );
          if ( response.status === 202 ) {
            GlobalService.onAxiosWarning( response, onWarning );
          }
          resolve( response.status === 201 );
        } )
        .catch( ( err: AxiosError ) => {
          GlobalService.onAxiosError( err, dispatch, onError );
        } );
    } );
  }

  static deleteEquipmentsOfTask(
    taskId: UUID,
    token: string | null, dispatch: Dispatch,
    onError?: CallbackErrorAxios, onWarning?: CallbackWarningAxios
  ): Promise<void> {
    return new Promise( async resolve => {
      AXIOS.delete( `${API.TASK_EQUIPMENT_BY_TASKS}/${taskId}`, await CommonGlobalService.getHeaderRequest( token ) )
        .then( ( response: AxiosResponse<string> ) => {
          CommonGlobalService.saveRequestToken( response, dispatch );
          if ( response.status === 202 ) {
            GlobalService.onAxiosWarning( response, onWarning );
          }
          resolve();
        } )
        .catch( ( err: AxiosError ) => {
          GlobalService.onAxiosError( err, dispatch, onError );
        } );
    } );
  }
};